import { put, takeEvery, call } from "redux-saga/effects";
import * as actionTypes from "./constants";
// import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";
import { push } from "connected-react-router";
import { toast } from "react-toastify";
import fmApi from "../APIWrapper";

function* forgotPassword(params) {
  let username = params?.params?.username || "";
  let data = {
    username: username,
  };
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/identityservice/society/recoverpass`,
    //   {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    const resJSON = yield call(fmApi.PostRecoverPassApi, data);
    if (resJSON?.status === "Success") {
      yield put({
        type: actionTypes.FORGOT_PASSWORD_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success("Email sent successfully", {
        autoClose: 3000,
      });
      yield put(push("/login"));
    } else {
      yield toast.error("User not found", {
        autoClose: 3000,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FORGOT_PASSWORD_FAIL_ACTION,
        error: err,
        payload: "",
      });
      yield toast.error("Failed to send email", {
        autoClose: 3000,
      });
    } else {
    }
  }
}

export function* forgotPasswordActionWatcher() {
  yield takeEvery(actionTypes.FORGOT_PASSWORD_INIT_ACTION, forgotPassword);
}
